import React from 'react';

import BenefitsParent from '@framework/ui/Pages/Landing/Sections/Benefits';
import styles from './benefits.module.scss';

const benefitsCollection = [
  {
    key: 'savingsGuarantee',
    title: 'Upfront Savings Guarantee',
    description: (
      <>
        <p>We provide potentially thousands in cost savings when you migrate.</p>
        <p>No maintenance for the first year and no contractual commitments to lock you in.</p>
      </>
    ),
  },
  {
    key: 'trialPeriod',
    title: 'Free 30-Day Trial Period',
    description: (
      <>
        <p>Confirm 17g5.com is the right fit with a <span>free 30-day trial</span>.</p>
        <p>
          No credit cards required with access to 100% of features and functionality,
          including our fanatical 24x7 U.S. based support.
        </p>
      </>
    ),
  },
  {
    key: 'migrationServices',
    title: 'Free Migration Services',
    description: (
      <>
        <p>We provide <span>free migration</span> services and credit pre-paid duration on your existing data room.</p>
        <p>
          We’ll replicate all existing files, folders, users and permissions so you can
          start using 17g5.com today.
        </p>
      </>
    ),
  },
];

const Benefits = () => (
  <div className={ styles.benefitsWrp }>
    <BenefitsParent
      className={ styles.benefitsContainer }
      titleClassName={ styles.benefitsTitle }
      descriptionClassName={ styles.benefitsDescription }
      collection={ benefitsCollection }
    />
  </div>
);

export default Benefits;
